module.exports = __webpack_public_path__ + "img/logo.e7e76f40.png";